import Frota from '../images/frota.png';

export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden bg-brand-light pt-20"
    >
      {/* Background decorative circle */}
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-brand-green/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-brand-gold/8 blur-3xl pointer-events-none" />

      {/* Gold vertical accent */}
      <div className="hidden md:block absolute left-0 top-1/4 bottom-1/4 w-1 bg-gradient-to-b from-transparent via-brand-gold to-transparent opacity-40" />

      <div className="max-w-5xl mx-auto px-5 w-full py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">

          {/* Text */}
          <div className="order-2 md:order-1">
            <div className="reveal" data-delay="0">
              <span className="inline-block text-xs tracking-[0.2em] uppercase text-brand-gold font-body font-semibold mb-4">
                Logística inteligente
              </span>
            </div>

            <h1 className="reveal font-display font-black leading-[0.95] text-brand-dark mb-6" data-delay="100"
              style={{ fontSize: 'clamp(2rem, 6vw, 4.5rem)' }}>
              Campos
              <br />
              <span className="text-brand-green">Transportes</span>
            </h1>

            <p className="reveal font-body text-base md:text-lg text-gray-600 leading-relaxed mb-8 max-w-sm" data-delay="200">
              A certeza que seu produto será entregue no prazo, e{' '}
              <strong className="text-brand-dark font-semibold">sem dor de cabeça</strong>.
            </p>

            <div className="reveal flex flex-wrap gap-3" data-delay="300">
              <a
                href="https://wa.me/11946384844"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-slide border border-brand-green text-brand-green font-body font-semibold px-7 py-3 rounded-sm text-sm tracking-wide transition-all duration-300"
              >
                Saiba mais
              </a>
              <a
                href="https://wa.me/11946384844"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body font-medium text-sm text-gray-500 hover:text-brand-green transition-colors px-4 py-3 flex items-center gap-2"
              >
                Fazer cotação
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>

            {/* Stats row */}
            <div className="reveal grid grid-cols-3 gap-4 mt-12 pt-8 border-t border-gray-200" data-delay="400">
              {[
                { value: '100%', label: 'Pontualidade' },
                { value: '24h', label: 'Rastreamento' },
                { value: '+500', label: 'Entregas/mês' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <div className="font-display font-bold text-2xl text-brand-green">{s.value}</div>
                  <div className="font-body text-xs text-gray-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end relative">
            <div className="relative w-full max-w-2xl">
              {/* Decorative behind shape */}
              <div className="absolute -inset-4 bg-brand-green/8 -rotate-3" />
              <img
                src={Frota}
                alt="Frota Campos Transportes - vans e caminhões"
                className="van-float relative w-full object-contain drop-shadow-2xl"
                style={{ maxHeight: '620px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              {/* Fallback placeholder */}
              <div
                className="hidden w-full aspect-square bg-brand-green/10 rounded-xl items-center justify-center"
                style={{ maxHeight: '620px' }}
              >
                <div className="text-center">
                  <svg className="w-24 h-24 text-brand-green/30 mx-auto" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                  </svg>
                  <p className="text-brand-green/40 text-sm mt-2 font-body">Sua imagem aqui</p>
                </div>
              </div>

              {/* Badge */}
              <div className="pulse-gold absolute -bottom-4 -left-4 bg-white shadow-lg rounded-sm px-4 py-2.5 border-l-4 border-brand-gold">
                <div className="font-body text-xs text-gray-500">Disponível agora</div>
                <div className="font-display font-bold text-brand-dark text-sm">Faça sua cotação</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
